import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { ButtonComponent, ModalComponent, ModalFooterDirective } from 'mbs-ui-kit';

@Component({
  selector: 'mbs-premium-support-activated-modal',
  standalone: true,
  templateUrl: './premium-support-activated-modal.component.html',
  styleUrls: ['./premium-support-activated-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, I18NextPipe, ButtonComponent, ModalComponent, ModalFooterDirective]
})
export class PremiumSupportActivatedModalComponent {
  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;

  public close(): void {
    this.baseModal.close();
  }
}
